<template>
  <div class="auth-container d-flex flex-row">
    <left-side-logo class="left-side"></left-side-logo>
    <div class="main-section d-flex flex-column flex-grow-1 align-items-center">
      <logo-component
        class="logo-component"
        :color="palette['light-primary-100']"
        height="32px"
      />
      <router-view class="right-side flex-grow-1" />
      <div
        class="footer d-flex flex-row align-items-center justify-content-center i-gap-9"
      >
        <a
          href="https://www.inscribe.ai/about"
          target="_blank"
          class="i-text-body-3 i-text-neutral-90"
          >About</a
        >
        <a
          href="https://www.inscribe.ai/privacy"
          target="_blank"
          class="i-text-body-3 i-text-neutral-90"
          >Privacy</a
        >

        <a
          class="i-text-body-3 i-text-neutral-90"
          @click="$emit('open-cookie-manager')"
          >Manage Cookies</a
        >

        <a
          href="https://www.inscribe.ai/"
          target="_blank"
          class="i-text-body-3 i-text-neutral-90"
          >© InscribeAI, Inc.</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import LeftSideLogo from '@/V2/auth/LeftSideLogo';
import LogoComponent from '@/V2/Logo';
import palette from '@inscribe/signal/dist/palette';

export default {
  components: { LeftSideLogo, LogoComponent },
  data: () => ({
    palette,
  }),
};
</script>

<style lang="scss" scoped>
.auth-container {
  height: 100%;

  :deep(.form) {
    width: 360px;

    a {
      color: $light-primary-110;
    }

    .i-button {
      width: 100%;
    }
  }

  :deep(.account-creation) {
    width: 100%;
    background: $light-neutral-20;
  }

  .left-side {
    width: 480px;
  }

  .main-section {
    .logo-component {
      display: none;
    }
  }

  @media only screen and (max-width: 860px) {
    .left-side {
      display: none !important;
    }

    .main-section {
      .logo-component {
        position: absolute;
        left: 50%;
        top: 5%;
        transform: translate(-50%, -50%);
        display: flex;
      }
    }
  }

  @media only screen and (max-width: 320px) {
    :deep(.form) {
      width: 240px;
    }
  }

  .footer {
    width: 100%;
    height: 80px;
  }
}
</style>
